import axios from "axios";

export const NCapi = axios.create({
  baseURL: "/api/",
});
